import React from "react";

import { formatCurrency } from "../utils/utils";

export default ({ code, description, pvp, dto, iva, pvu, uds, total }) => {
  return (
    <div className="section-patient-sale-history-table-row">
      <div>
        <span>{code}</span>
      </div>
      <div>
        <span>{description}</span>
      </div>
      <div className="section-patient-sale-history-align-end">
        <span>{formatCurrency(pvp)}</span>
      </div>
      <div className="section-patient-sale-history-align-center">
        {/* El dto se guarda como float, pero se muestra redondeado al entero. */}
        <span>{Math.round(parseFloat(dto) || 0)} %</span>
      </div>
      <div className="section-patient-sale-history-align-center">
        <span>{iva} %</span>
      </div>
      <div className="section-patient-sale-history-align-end">
        <span>{formatCurrency(pvu)}</span>
      </div>
      <div className="section-patient-sale-history-align-center">
        <span>{uds}</span>
      </div>
      <div className="section-patient-sale-history-align-end">
        <span>{formatCurrency(total)}</span>
      </div>
    </div>
  );
};
